import React, { useEffect, useRef } from 'react';
import { useLang } from './i18n';

declare global { interface Window { turnstile?: { render: (el: HTMLElement, o: Record<string, unknown>) => string; reset: (id?: string) => void; remove: (id: string) => void }; } }

let loader: Promise<void> | null = null;
let current = '';
function load() {
  if (window.turnstile) return Promise.resolve();
  loader ||= new Promise((ok, bad) => {
    const s = document.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    s.async = true;
    s.onload = () => ok();
    s.onerror = () => { loader = null; bad(new Error('captcha')); };
    document.head.appendChild(s);
  });
  return loader;
}
export function resetCaptcha() { try { if (current) window.turnstile?.reset(current); } catch {} }

// Cloudflare Turnstile widget. It adds the hidden cf-turnstile-response field to the surrounding form.
export function Captcha({ siteKey }: { siteKey: string }) {
  const ref = useRef<HTMLDivElement>(null);
  const [lang] = useLang();
  useEffect(() => {
    let id = '', gone = false;
    load().then(() => {
      if (gone || !ref.current || !window.turnstile) return;
      // Without an error callback Turnstile throws; the widget itself shows the error and retries.
      id = window.turnstile.render(ref.current, { sitekey: siteKey, theme: 'dark', language: lang === 'de' ? 'de' : 'en', 'refresh-expired': 'auto', 'error-callback': () => true });
      current = id;
    }).catch(() => {});
    return () => { gone = true; if (id) { try { window.turnstile?.remove(id); } catch {} if (current === id) current = ''; } };
  }, [siteKey, lang]);
  return <div className="auth-captcha" ref={ref} />;
}
